import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import { Form, input } from "antd";
import Select from "react-select"
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import moment from "moment";
import {Label, UncontrolledTooltip} from "reactstrap";
import './DocumentList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import UploaderDocument from "../../components/Uploader/UploaderDocument";
import 'react-datetime/css/react-datetime.css';

const {TextArea} = input;

class DocumentIncomingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            emailAvailabilityError: {},
            documentFile: [],
            notFileName: [],
            loading: false,
            isLoading: false,
            fieldsDisabled: false,
            mode: this.props.mode,
            selectedUsers:null,
            selectedGroups:null,
            notes: {},
            files:{},

        };

        this.documentIncoming = this.documentIncoming.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeDocument = this.onChangeDocument.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.onChangeDateString = this.onChangeDateString.bind(this);
        this.getDocumentFile = this.getDocumentFile.bind(this);
        this.getNotFileUserName = this.getNotFileUserName.bind(this);
    }

    componentDidMount() {
        this.getDocumentFile()
        this.getNotFileUserName()
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }
    onChangeSelect(name, value) {
        let documentInfo = this.state.documentInfo;
        if (value === null) {
            documentInfo[name] = null
        } else {
            documentInfo[name] = value.value;
        }
        this.setState({documentInfo});
    }
    onSelectInfoChange(name,value){
        let documentInfo=this.state.documentInfo;
        console.log("value",value);
        console.log("documentInfo",documentInfo);
        if(value===null) {
            documentInfo[name]=[];
        }
        else {
            documentInfo[name]=[];
            documentInfo[name]=value.slice();
        }
        this.setState({documentInfo });
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChangeDocument(name, value) {

        if (value instanceof moment) {
            value = moment.utc(value.format('DD.MM.YYYY').toString() + " 00:00", "DD.MM.YYYY HH:mm");
        }
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value;
        this.setState({documentInfo});
    }

    onChangeDateString(name, value) {
            let documentInfo = this.state.documentInfo;
            if (value === "") {
                documentInfo[name] = null;
                this.setState({documentInfo});
            } else {
                let splitted = value.split(".");
                if (splitted.length === 3) {
                    value = splitted[2] + "-" + splitted[1] + "-" + splitted[0];
                    documentInfo[name] = value;
                    this.setState({documentInfo});
                } else {
                    documentInfo[name] = 'Tarih bilgisi boş';
                    this.setState({documentInfo});
                }
            }
        }

    onChangeDocumentLowerCase(name, value) {
        let documentInfo = this.state.documentInfo;
        documentInfo[name] = value.toString().toLocaleLowerCase();
        this.setState({documentInfo});
    }

    onSelectChange(name, value) {
        let documentInfo = this.state.documentInfo;
        if (value === null) {
            documentInfo[name] = null
        } else {
            documentInfo[name] = value.value;
        }
        this.setState({documentInfo});
    }

    documentIncoming() {
        let self = this;
        let params;
        let data;
        let message;
        self.setState({isLoading: true});
        let document = deepCopyObject(this.props.selectedDocument);
        document = trimObject(document);
        data = document;

        if (document.id === null) {
            message = 'Evrak Bilgileri Başarıyla Kaydedildi.'
            params = {
                url: API_BASE_URL + "/evrakSevk",
                data: data,
                method: 'post'
            };
        } else {
            message = 'Evrak Okundu.'
            params = {
                url: API_BASE_URL + "/evrakSevk/updateEvrakSevk",
                data: data,
                method: 'patch'
            };
        }

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({isLoading: false});
            this.cancelProcess();
            self.props.handleSearch(self.props.searchQuery, true);
        }).catch(function (error) {
            self.setState({isLoading: false});
            // showAxiosError(error);  // burası veri çekerken hata alınca alert veriyor...
        });
    }
    /*

    getDocumentFile() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/evrakSevkNotFile",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let content = response.data.content;
                console.log("documentFile", response.data.content)
                self.setState({
                    documentFile: {
                        ...self.state.documentFile,
                        content
                    },
                }, () => {console.log("newDocumentFile::", self.state.documentFile)});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    */

getDocumentFile() {
    let self = this;
    let evrakId = this.props.selectedDocument.id;
    let params = {
        url: `${API_BASE_URL}/evrakSevk/evrak/${evrakId}`,
        method: "get",
    };
    request(params)
        .then(function (response) {
            let files = response.data;

            delete files.id;
            delete files.evrakSevkId;
            delete files.cuserName;
            delete files.cuserSurname;
            let documentFile = files.map(file => file.path);
            self.setState({
                documentFile: documentFile,
            }, () => {
                console.log("newDocumentFile::", self.state.documentFile);
            });
        }).catch(function (error) {
        showAxiosError(error);
    });
}





    getNotFileUserName() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/user/userName-surname",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let notFileName = response.data;
                console.log("notFileName", response.data)
                self.setState({
                    notFileName
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        let sureBitisTarihi = this.props.selectedDocument.sureBitisTarihi ? {value: moment.utc(this.props.selectedDocument.sureBitisTarihi, "DD.MM.YYYY")} : {};
        console.log("this.props.selectedDocument", this.props.selectedDocument)
        console.log("evrakSevkNotFile:", this.props.selectedDocument.evrakSevkNotFile);

        return (
            <div className="memberForm--main-container">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                    <Form>
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Evrak Bilgileri</span>
                            <div className="row">
                                <Label className="col-sm-3">Oda İl: </Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('odaIl')}>
                                    <input className="form-control uppercase"
                                           disabled
                                           type="text"
                                           name="odaIl"
                                           id="odaIl"
                                           value="Şanlıurfa"
                                        // value={this.state.documentInfo.odaIl || ""}
                                    />
                                    {this.validateMessage('odaIl') !== "" &&
                                    <UncontrolledTooltip placement="right" target="odaIl" delay={0}>
                                        {this.validateMessage("odaIl")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                            {/*{(this.state.documentInfo.id !== null) &&*/}
                            <div className='row'>
                                <label className="col-sm-3">Evrak No: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakNo')}>
                                    <input className="form-control"
                                           disabled={this.props.selectedDocument}
                                           type="text"
                                           name="evrakNo"
                                           id="evrakNo"
                                           // defaultValue={this.props.selectedDocument.evrakNo}
                                           value={this.props.selectedDocument.evrakNo || ""}
                                           onChange={(e) => this.onChangeDocument("evrakNo", e.target.value)}
                                    />
                                    {this.validateMessage('evrakNo') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakNo" delay={0}>
                                        {this.validateMessage("evrakNo")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">İlgili Yer: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakIlgiliYer')}>
                                    <input className="form-control uppercase"
                                           disabled={this.props.selectedDocument}
                                           type="text"
                                           name="evrakIlgiliYer"
                                           id="evrakIlgiliYer"
                                           defaultValue={this.props.selectedDocument.evrakIlgiliYer || ""}
                                           onChange={(e) => this.onChangeDocumentLowerCase("evrakIlgiliYer", e.target.value)}
                                    />
                                    {this.validateMessage('evrakIlgiliYer') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakIlgiliYer" delay={0}>
                                        {this.validateMessage("evrakIlgiliYer")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className='row'>
                                <label className="col-sm-3">Evrak Adı: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('evrakKonu')}>
                                    <input className="form-control uppercase"
                                           disabled={this.props.selectedDocument}
                                           type="text"
                                           name="evrakKonu"
                                           id="evrakKonu"
                                           defaultValue={this.props.selectedDocument.evrakKonu || ""}
                                           // value={this.props.selectedDocument.evrakKonu || ""}
                                           onChange={(e) => this.onChangeDocumentLowerCase("evrakKonu", e.target.value)}
                                    />
                                    {this.validateMessage('tUsername') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tUsername" delay={0}>
                                        {this.validateMessage("tUsername")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Evrak Türü:</Label>
                                <div className={"col-sm-8 form-group" + this.validateClass('belgeTuru')}>
                                    <input className="form-control"
                                           disabled={this.props.selectedDocument}
                                           type="text"
                                           name="belgeTuru"
                                           id="belgeTuru"
                                           defaultValue={this.props.selectedDocument.belgeTuru || ""}
                                           // value={this.state.documentInfo.belgeTuru || ""}
                                           onChange={(value) => this.onSelectChange("belgeTuru", value)}
                                    />
                                    {this.validateMessage('belgeTuru') !== "" &&
                                    <UncontrolledTooltip placement="right" target="belgeTuru" delay={0}>
                                        {this.validateMessage("belgeTuru")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-3">Geçerlilik Tarihi:</Label>
<div className={"col-sm-8 form-group" + this.validateClass('sureBitisTarihi')}>
                                    <input {...sureBitisTarihi}
                                        className="basic-single"
                                        disabled={this.props.selectedDocument}
                                        name="sureBitisTarihi"
                                        id="sureBitisTarihi"
                                        format="DD.MM.YYYY"
                                        ref="sureBitisTarihi"
                                        style={{width: "100%"}}
                                       value={(this.props.selectedDocument && this.props.selectedDocument.sureBitisTarihi && moment(this.props.selectedDocument.sureBitisTarihi).isValid()) ? moment(this.props.selectedDocument.sureBitisTarihi).format("DD.MM.YYYY") : "Tarih bilgisi boş"}

                                        onChange={(date) => this.onChangeDocument("sureBitisTarihi", date)}
                                    />
                                    {this.validateMessage('sureBitisTarihi') !== "" &&
                                    <UncontrolledTooltip placement="right" target="sureBitisTarihi" delay={0}>
                                        {this.validateMessage("sureBitisTarihi")}
                                    </UncontrolledTooltip>}
                                    </div>
                            </div>

                            <div>
                                <div className="row">
                                    <Label className="col-sm-3">Dosya:</Label>
                                    <div className={"col-sm-8 form-group" + this.validateClass('evrakPath')}>
                                        <a className="form-control"
                                           id="evrakPath"
                                           href={this.props.selectedDocument.evrakPath}
                                           target="_blank"
                                               // onChange={(e) => this.onChangeDocumentUpperCase("evrakPath")}
                                        >
                                            {this.props.selectedDocument.evrakPath || ""}
                                        </a>
                                        {this.validateMessage('evrakPath') !== "" &&
                                        <UncontrolledTooltip placement="right" target="evrakPath" delay={0}>
                                            {this.validateMessage("evrakPath")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <label className="col-sm-3">Süreli Evrak: </label>
                                <div className={"col-sm-8 form-group" + this.validateClass('sureliMi')}>

                                    <h6>{this.props.selectedDocument && this.props.selectedDocument.sureliMi ? "Evet" : "Hayır"}</h6>
                                </div>
                            </div>
                        </div>

                        {
                            this.props.selectedDocument !== null &&
                            this.props.selectedDocument !== "null" &&
                            this.props.selectedDocument !== undefined &&
                                <div className="FormRenk col-sm-12">
                                    <span className="form-title">Açıklama</span>
                                    <div className="row">
                                        <Label className="col-sm-3"> Evrak açıklaması: </Label>
                                        <div
                                            className={"col-sm-8 form-group" + this.validateClass('aciklama')}>
                                            <h4 className="form-control" id="aciklama">
                                                {this.props.selectedDocument.evrakAciklama}
                                            </h4>
                                            {this.validateMessage('aciklama') !== "" &&
                                            <UncontrolledTooltip placement="right" target="aciklama"
                                                                 delay={0}>
                                                {this.validateMessage("aciklama")}
                                            </UncontrolledTooltip>}
                                        </div>
                                    </div>
                                </div>
                        }
                        {   this.props.selectedDocument !== null &&
                            this.props.selectedDocument !== "null" &&
                            this.props.selectedDocument !== undefined &&
                            this.state.documentFile &&
                            this.state.documentFile.content &&
                            this.state.documentFile.content.length > 0 &&
                        <div className="FormRenk col-sm-12">
                            <span className="form-title">Dosya</span>
                            <div className="row">
                                <Label className="col-sm-3">Dosya: </Label>
                                <div
                                    className={"col-sm-8 form-group" + this.validateClass('file')}>
                                  {this.state.documentFile.map((file, index) =>
                                      <div key={index}>
                                          <label className="mt-1">Dosya {index + 1}</label>
                                          <a className="form-control" style={{ overflowX: "scroll" }} href={file.path} target="_blank">
                                              {file.path}
                                          </a>
                                      </div>
                                  )}

                                    {this.validateMessage('evrakAciklama') !== "" &&
                                    <UncontrolledTooltip placement="right" target="evrakAciklama"
                                                         delay={0}>
                                        {this.validateMessage("evrakAciklama")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        }
                       {this.props.selectedDocument.evrakSevkNots.length > 0 && (
                     <div className="FormRenk col-sm-12">
                         <span className="form-title">Notlar</span>
                         {this.props.selectedDocument.evrakSevkNots.map((not, index) => (
                             <div key={index}>
                                 <div className="row">
                                     <Label className="col-sm-3">Not: </Label>
                                     <div className={"col-sm-8 form-group" + this.validateClass('evrakAciklama')}>
                                         <label>{not.not}</label>
                                     </div>
                                 </div>

                             </div>
                         ))}

                         {this.state.documentFile && this.state.documentFile.length > 0 && (
                             <div>
                                 {this.state.documentFile.map((path, index) => (
                                     <div key={index}>
                                         <p>Dosya: {path}</p>

                                     </div>
                                 ))}
                             </div>
                         )}

                     </div>

                       )}









                    </Form>
                    <div className="save-button-container">
                        <button onClick={() => {
                            this.documentIncoming()
                        }}
                                className="member-save-button"
                                disabled={this.state.isLoading}
                        >
                            TAMAM
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default DocumentIncomingModal;;



// WEBPACK FOOTER //
// ./src/page/documentList/DocumentIncomingModal.js